const hr = {
    common: {
        appName: "LearnOS",
        signIn: "Prijava",
        startFree: "Započni besplatno",
        getStarted: "Kreni",
        tryFree: "Isprobaj besplatno",
        watchDemo: "Pogledaj demo",
        seeInAction: "Pogledaj LearnOS u akciji",
        cancel: "Odustani",
        delete: "Izbriši",
        retry: "Pokušaj ponovno",
        loading: "Učitavanje…",
        included: "Uključeno",
        comingSoon: "Uskoro",
        placeholder: "Rezervirano",
    },
    nav: {
        problem: "Problem",
        howItWorks: "Kako radi",
        features: "Značajke",
        tour: "Obilazak",
        testimonials: "Dojmovi",
        modes: "Načini čitanja",
        rewards: "Nagrade",
        groupLibrary: "Knjižnica",
        groupLearn: "Učenje",
        groupAccount: "Račun",
        library: "Knjižnica",
        analytics: "Analitika",
        learnDashboard: "Nadzorna ploča",
        flashcards: "Kartice",
        review: "Ponavljanje",
        examMode: "Ispitni način",
        profile: "Profil",
        signOut: "Odjava",
        tagline: "uči brže",
        brandTag: "AI Learning OS",
        language: "Jezik",
        groupEarn: "Program",
        ambassador: "Ambasador",
        admin: "Admin",
        pricing: "Cijene",
        upgrade: "Nadogradi",
    },
    landing: {
        heroBadge: "Tvoj osobni AI mentor",
        heroTitle1: "Učitaj bilo što.",
        heroTitle2: "Nauči sve.",
        heroSubtitle: "LearnOS nije čitač PDF-ova. Pretvara bilo koju knjigu, PDF ili skriptu u sažetke, kartice, kvizove i probne ispite — uz osobnog AI mentora koji ti pomaže zapamtiti više i položiti ispite.",
        heroModesLabel: "4 ugrađena načina čitanja",
        heroModes: [
            { name: "RSVP", tag: "Riječ po riječ" },
            { name: "Ticker", tag: "Tok teleprompter-a" },
            { name: "Vođeno", tag: "Isticanje te vodi" },
            { name: "Fokus", tag: "Bez ometanja" },
        ],
        trust1: "Bez kreditne kartice",
        trust2: "Bilo koji PDF, knjiga ili skripta",
        trust3: "Besplatan početak",
        problem: {
            label: "Problem",
            title: "Učenje se nije promijenilo desetljećima.",
            body: "Ljudi i dalje čitaju stotine stranica, podcrtavaju, zaborave većinu i bubaju pred ispite. Rezultat: izgubljeno vrijeme, slabo pamćenje i stalna frustracija.",
            cards: [
                { title: "Čitanje stotina stranica", desc: "Sati pasivnog čitanja s malo rezultata." },
                { title: "Podcrtaj i zaboravi", desc: "Podcrtavanje djeluje produktivno — ali jedva pomaže pamćenju." },
                { title: "Bubanje i panika", desc: "Bubanje u zadnji čas koje izblijedi danima nakon ispita." },
            ],
        },
        solution: {
            label: "Rješenje",
            title: "Upoznaj svog osobnog AI mentora.",
            body: "LearnOS ti ne pomaže samo čitati. Pomaže ti razumjeti, zapamtiti i primijeniti znanje — automatski.",
            pillars: [
                { title: "Razumjeti", desc: "AI razlaže složeno gradivo na ideje koje stvarno shvatiš." },
                { title: "Zapamtiti", desc: "Aktivno dosjećanje i razmaknuto ponavljanje trajno učvršćuju znanje." },
                { title: "Primijeniti", desc: "Kvizovi, ispiti i mentorstvo pretvaraju znanje u stvarnu vještinu." },
            ],
        },
        journey: ["Učitavanje", "AI sažetak", "Načini čitanja", "Razgovor", "Kartice", "Kviz", "Ispitni način", "Praznine u znanju", "AI trener", "Majstorstvo"],
        how: {
            label: "Kako radi",
            title: "Od dokumenta do majstorstva u četiri koraka",
            step: "Korak",
            steps: [
                { title: "Učitaj bilo koji sadržaj", desc: "Knjige, PDF-ovi, skripte, izvještaji, istraživanja — sve što trebaš naučiti." },
                { title: "AI razumije sadržaj", desc: "Izvlači strukturu, ključne ideje, definicije i odnose." },
                { title: "Uči pametnije", desc: "Kartice, kvizovi, simulacije ispita i aktivno dosjećanje." },
                { title: "Ovladaj znanjem", desc: "Pronađi slabe točke, prati napredak i napreduj uz AI trenera." },
            ],
        },
        features: {
            label: "Značajke",
            title: "Cjelovita AI platforma za učenje — ne samo čitač",
            body: "Sažeci, mentor, kartice, kvizovi, ispiti, otkrivanje praznina i trener — sve na jednom mjestu. Brzo čitanje je samo jedan alat u njemu.",
            items: [
                { title: "AI mentor", desc: "Tvoj osobni mentor za bilo koji dokument — pitaj bilo što i dobij odgovore iz samog izvora." },
                { title: "AI sažeci", desc: "Sažeci od 1 minute, 5 minuta i detaljni — odmah, za bilo što." },
                { title: "Razgovor s dokumentima", desc: "Vodi pravi razgovor sa svojim knjigama i PDF-ovima — uz navođenje stranica." },
                { title: "Kartice", desc: "Automatski generirane kartice za učenje aktivnim dosjećanjem." },
                { title: "Generator kvizova", desc: "Provjeri razumijevanje kvizovima iz tvog gradiva." },
                { title: "Ispitni način", desc: "Vremenski ograničeni probni ispiti koji djeluju stvarno." },
                { title: "Otkrivanje praznina u znanju", desc: "Otkrij točno koje teme još ne razumiješ." },
                { title: "Izdvajanje znanja", desc: "Ključni pojmovi, definicije i odnosi automatski izdvojeni." },
                { title: "AI trener", desc: "Personalizirane preporuke na temelju tvog stvarnog napretka." },
                { title: "Analitika čitanja", desc: "Prati pamćenje, majstorstvo i cijelo putovanje učenja." },
                { title: "Načini čitanja", desc: "Čitaj na svoj način: ugrađeni RSVP, Ticker i Fokus način." },
                { title: "Brzo čitanje", desc: "Upijaj sadržaj znatno brže — jedan alat u sustavu." },
            ],
        },
        readingModes: {
            label: "Načini čitanja",
            title: "Četiri načina čitanja — ugrađena",
            body: "Većina aplikacija nudi jedan način čitanja. LearnOS nudi četiri, da način prilagodiš gradivu.",
            modes: [
                { name: "RSVP način", desc: "Riječi se prikazuju jedna po jedna tvojom željenom brzinom — brže čitaj uz manje pomicanja očiju." },
                { name: "Ticker način", desc: "Tekst klizi po fiksnoj liniji poput teleprompter-a za glatki, ujednačeni tempo." },
                { name: "Vođeno čitanje", desc: "Tekst miruje dok te pametno isticanje vodi kroz njega — smireno i prirodno." },
                { name: "Fokus čitanje", desc: "Zatamni sve osim retka na kojem si, da ostaneš usredotočen i bez ometanja." },
            ],
        },
        personas: {
            label: "Stvoreno za tebe",
            title: "Za studente, profesionalce i one koji uče cijeli život",
            items: [
                { title: "Studenti", desc: "Pretvori predavanja i udžbenike u aktivno dosjećanje, kartice i kvizove.", tags: ["Medicina", "Pravo", "Ekonomija"] },
                { title: "Priprema za ispite", desc: "Probni ispiti, otkrivanje praznina i AI trener usmjeren na tvoje slabe točke.", tags: ["Državni ispiti", "Završni ispiti", "Certifikati"] },
                { title: "Profesionalci", desc: "Brže se usavršavaj i zapamti više iz gustog gradiva.", tags: ["Certifikati", "Stručno usavršavanje"] },
                { title: "Doživotni učenici", desc: "Čitaj pametnije i stvarno zapamti ono što ti je važno.", tags: ["Knjige", "Tečajevi", "Istraživanje"] },
            ],
        },
        comparison: {
            label: "Razlika",
            title: "Klasično učenje vs. LearnOS",
            traditional: "Klasično",
            traditionalFlow: "Čitaj → Zaboravi",
            traditionalBullets: ["Ručno podcrtavanje", "Bubanje pred ispite", "Slabo dugoročno pamćenje"],
            learnos: "LearnOS",
            learnosFlow: "Čitaj → Razumij → Zapamti → Ovladaj",
            learnosBullets: ["Vodstvo AI mentora", "Aktivno dosjećanje + razmaci", "Napredak + otkrivanje praznina"],
            positioningLabel: "Pozicioniranje",
            positioningTitle: "Drugi AI alati pomažu čitati. LearnOS pomaže položiti.",
            positioning: [
                { from: "Asistent za istraživanje", to: "Osobni AI mentor" },
                { from: "Razumjeti dokumente", to: "Položiti ispite" },
                { from: "Informacije", to: "Dugoročno pamćenje" },
                { from: "Čitanje", to: "Majstorstvo" },
                { from: "Obrada dokumenata", to: "Cjelovit sustav za učenje" },
            ],
        },
        tour: {
            label: "Interaktivni obilazak",
            title: "Prođi kroz putovanje",
            body: "Pogledaj kako LearnOS od jednog dokumenta stvara osobnog AI mentora.",
            steps: [
                { title: "Učitaj PDF", caption: "Počni s bilo kojim dokumentom." },
                { title: "Dobij AI sažetak", caption: "Razumij ključne ideje u nekoliko minuta." },
                { title: "Postavljaj pitanja", caption: "Razgovaraj izravno sa svojim gradivom." },
                { title: "Generiraj kartice", caption: "Pretvori informacije u pamćenje." },
                { title: "Riješi kviz", caption: "Provjeri što stvarno znaš." },
                { title: "Riješi probni ispit", caption: "Vremenski ograničena vježba koja djeluje stvarno." },
                { title: "Pronađi praznine u znanju", caption: "Otkrij što treba više pažnje." },
                { title: "Napreduj uz AI trenera", caption: "Dobij personalizirane preporuke." },
            ],
        },
        social: {
            label: "Što kažu polaznici",
            title: "Vole ga ljudi koji puno uče",
            testimonials: [
                { role: "Student", quote: "Da sam ovo imao prije nekoliko godina — vrijeme učenja prepolovljeno." },
                { role: "Student medicine", quote: "Prikaz praznina u znanju točno mi pokaže što ponoviti prije ispita." },
                { role: "Student prava", quote: "Pretvaranje slučajeva u vježbe konačno je strukturiralo pripremu za ispit." },
                { role: "Poduzetnik", quote: "Mogu brzo naučiti bilo koju temu bez gubljenja važnih detalja." },
                { role: "Profesionalac", quote: "Savršeno za certifikate — kvizovi i mentorstvo drže me dosljednim." },
            ],
        },
        finalCta: {
            title: "Prestani čitati. Počni učiti.",
            body: "Pridruži se novoj generaciji učenja uz AI.",
        },
        ambassadorBlock: {
            label: "Student Ambassador Program",
            title: "Pozovi prijatelje. Zaradi ponavljajuće nagrade.",
            body: "Ulažemo u svoju zajednicu umjesto u skupo oglašavanje. Podijeli LearnOS s ljudima oko sebe, zarađuj ponavljajuće nagrade dok oni uče i postani dio putovanja.",
            point1: "Ponavljajuće nagrade za svakog aktivnog člana kojeg dovedeš",
            point2: "Otključaj besplatne Pro i Premium mjesece kako rasteš",
            point3: "Postani dio LearnOS putovanja — ne prodavač",
            cta: "Postani ambasador",
        },
        footer: { tagline: "učitaj · razumij · zapamti · ovladaj" },
    },
    preview: {
        onePlatform: "jedna platforma",
        step: "korak",
        upload: { drop: "Ispusti PDF, EPUB ili zalijepi poveznicu", dragDrop: "Povuci i ispusti datoteku", formats: "PDF · EPUB · DOCX · TXT · URL", parsed: "Obrađeno", parsing: "Obrada…" },
        summary: { label5: "Sažetak od 5 min", title5: "Sažetak od 5 minuta", bullets: ["Glavna teza u jednoj rečenici.", "Tri sile koje određuju ishod.", "Što s tim učiniti sutra."], tourBullets: ["Učenje je vještina koja se trenira, a ne fiksna osobina.", "Pamćenje dolazi iz aktivnog dosjećanja i razmaknute vježbe, ne ponovnog čitanja.", "Male, redovite sesije nadmašuju povremeno bubanje."], terms: ["nadogradnja", "pamćenje", "dosjećanje"], ask: "Postavi pitanje o ovom sažetku" },
        speed: { wpm: "RSVP · 450 WPM", oneFeature: "jedan od mnogih alata" },
        chat: { q1: "Koji je glavni argument?", a1: "Dosljedna mala vježba zbraja se u majstorstvo.", tourQ1: "Koji je najveći faktor za pamćenje?", tourA1: "Aktivno dosjećanje — propitivanje sebe umjesto ponovnog čitanja. Uz razmake najjače djeluje.", tourQ2: "Daj mi 3 pitanja za samoprovjeru." },
        flashcard: { question: "Pitanje", answer: "Odgovor", q: "Što je razmaknuto ponavljanje?", a: "Ponavljanje gradiva u sve većim razmacima radi borbe protiv krivulje zaboravljanja.", tapReveal: "Dodirni karticu za prikaz odgovora", rate: "Ocijeni dosjećanje: Ponovno · Dobro · Lako", activeRecall: "Aktivno dosjećanje", card: "Kartica" },
        quiz: { q: "Što najviše jača pamćenje?", tourQ: "Koja metoda najviše poboljšava dugoročno pamćenje?", options: ["Ponovno čitanje", "Aktivno dosjećanje", "Podcrtavanje"], tourOptions: ["Ponovno čitanje poglavlja", "Aktivno dosjećanje + razmaci", "Podcrtavanje ključnih rečenica"], question: "Pitanje", pick: "Odaberi odgovor za trenutnu povratnu informaciju", correct: "Točno — aktivno dosjećanje + razmaci pobjeđuju.", wrong: "Ne baš — aktivno dosjećanje + razmaci su najbolji." },
        gaps: { need: "tema za ponavljanje", needMore: "tema treba više pažnje", confident: "sigurnost", topics: ["Intervali nadogradnje", "Vrijeme dosjećanja"], tourTopics: ["Intervali nadogradnje", "Dosjećanje vs. prepoznavanje", "Optimalno trajanje sesije"], reviewNow: "Ponovi slabe teme sada" },
        coach: { todayPlan: "Današnji plan", yourPlan: "Tvoj plan za danas", items: ["Ponovi 8 dospjelih kartica", "Ponovi kviz: Intervali (10 min)"], tourItems: ["Ponovi 8 dospjelih kartica (≈ 6 min)", "Ponovi kviz: Intervali nadogradnje", "Pročitaj 1 odjeljak o trajanju sesije"], streakLine: "Sljedeća sesija održava tvoj niz od 12 dana" },
        exam: { mock: "Probni ispit", timeLeft: "Preostalo vrijeme", q: "Pitanje 4 / 20", prompt: "Koja metoda daje najjače dugoročno pamćenje?", options: ["Ponovno čitanje bilježaka", "Aktivno dosjećanje na vrijeme", "Podcrtavanje ključnih redaka"], submit: "Predaj ispit", graded: "Automatski ocijenjeno · trenutni rezultat" },
        mastery: { streak: "Niz od 12 dana", mastered: "124 svladane kartice", retention: "Pamćenje 86%" },
    },
    auth: {
        login: {
            title: "Dobrodošao natrag",
            subtitle: "Prijavi se za nastavak učenja.",
            email: "E-pošta",
            emailPlaceholder: "ti@primjer.com",
            password: "Lozinka",
            passwordPlaceholder: "Tvoja lozinka",
            submit: "Prijava",
            demo: "Koristi demo račun",
            noAccount: "Nemaš račun?",
            signUp: "Registracija",
            invalid: "Neispravna e-pošta ili lozinka",
            welcome: "Dobrodošao natrag!",
        },
        register: {
            title: "Stvori račun",
            subtitle: "Počni danas čitati i učiti brže.",
            name: "Ime",
            namePlaceholder: "Ada Lovelace",
            email: "E-pošta",
            emailPlaceholder: "ti@primjer.com",
            password: "Lozinka",
            passwordPlaceholder: "Najmanje 6 znakova",
            submit: "Stvori račun",
            haveAccount: "Već imaš račun?",
            signIn: "Prijava",
            pwShort: "Lozinka mora imati najmanje 6 znakova",
            created: "Račun stvoren — dobrodošao!",
            failed: "Stvaranje računa nije uspjelo",
            invitedBy: "{name} te pozvao/la na LearnOS",
            refApplied: "Pozivnica ambasadora primijenjena",
        },
    },
    rset: {
        title: "Postavke čitanja",
        subtitle: "Prilagodi kretanje, izgled i isticanje",
        movement: "Kretanje",
        display: "Izgled",
        highlight: "Isticanje",
        granularity: "Jedinica",
        grain: { word: "Riječ", phrase: "Fraza", sentence: "Rečenica" },
        autoScroll: "Auto-pomicanje",
        dim: "Zatamni ostatak",
        readingFocus: "Fokus čitanja",
        focusMode: { minimal: "Minimalno", word: "Aktivna riječ", trail: "Svjetlosni trag" },
        trailLength: "Duljina traga",
        trailLen: { short: "Kratko", medium: "Srednje", long: "Dugo" },
        textAlign: "Poravnanje teksta",
        alignLeft: "Lijevo",
        alignJustify: "Obostrano",
        theme: "Način",
        font: "Font",
        fontNote: { dyslexia: "Disleksija", sans: "Sans", serif: "Serif" },
        size: "Veličina",
        width: "Širina teksta",
        wNarrow: "Usko",
        wStandard: "Standard",
        wWide: "Široko",
        lineHeight: "Prored",
        lhCompact: "Kompaktno",
        lhStandard: "Standard",
        lhAiry: "Prozračno",
        reset: "Vrati na zadano",
        activeWord: "Aktivna riječ",
        activeWordHint: "Mijenja se samo boja teksta trenutne riječi — bez okvira.",
        wordAnchor: "Sidro riječi",
        anchor: { off: "Isključeno", "2": "2", "3": "3", "4": "4", "2l": "2 + zadnje", "3l": "3 + zadnje", auto: "Auto" },
        intensity: "Intenzitet",
        smartHighlights: "AI pametna isticanja",
        analyzing: "Analiziram dokument …",
        noHighlightsYet: "Za ovaj dokument još nisu izrađena AI pametna isticanja.",
        noHighlights: "Nema pronađenih isticanja.",
        generate: "Generiraj AI pametna isticanja",
        guidedDesc: "Bojani trag vodi tvoj tempo · cijeli tekst ostaje vidljiv",
        focusDesc: "Aktivna rečenica u fokusu · ostatak blago zatamnjen",
        smartHint: "AI ističe najvažnije dijelove. Odaberi u nastavku što se označava.",
        presets: {
            label: "Brzi odabir",
            hint: "Jedan klik kombinira odgovarajuće slojeve isticanja.",
            custom: "Vlastito",
            recommend: "Preporučeno za ovaj dokument",
            apply: "Primijeni",
            firstReading: "Prvo čitanje",
            revision: "Ponavljanje",
            medical: "Ispit medicine",
            law: "Ispit prava",
            business: "Ispit ekonomije",
        },
        domainLabel: { medical: "Medicinski pojmovi", legal: "Pravni pojmovi", business: "Poslovni pojmovi" },
        hlCat: {
            definitions: { label: "Definicije", desc: "Pojmovi definirani u tekstu — temelj za razumijevanje.", style: "Tirkizno, puna crta" },
            concepts: { label: "Ključni koncepti", desc: "Središnje ideje oko kojih se tema vrti.", style: "Plavo, isprekidana crta" },
            exam_relevant: { label: "Važno za ispit", desc: "Činjenice koje se često provjeravaju na ispitima.", style: "Jantarno, jako ispunjeno" },
            entities: { label: "Entiteti", desc: "Imena, mjesta, organizacije i vlastita imena.", style: "Magenta, točkasta crta" },
            domain: { label: "Stručni pojmovi", desc: "Stručno nazivlje tvog područja.", style: "Zeleno, dvostruko podcrtano" },
            numbers: { label: "Datumi i brojevi", desc: "Datumi, količine, doze i ključni podaci.", style: "Cijan, puna crta" },
            keywords: { label: "AI ključne riječi", desc: "Dodatne ključne riječi koje je AI prepoznao.", style: "Sivi okvir" },
        },
    },
    workspace: {
        hubTitle: "Tvoji radni prostori",
        hubSubtitle: "Grupiraj više izvora u jedan predmet — tvoj AI profesor poznaje ih sve odjednom.",
        new: "Novi radni prostor",
        defaultName: "Moja biblioteka",
        home: "Početna",
        backToHub: "Natrag na radne prostore",
        emptyTitle: "Stvori svoj prvi radni prostor",
        emptyBody: "Radni prostor objedinjuje predavanja, knjige, smjernice i tvoje bilješke u JEDNU bazu znanja. Razgovaraj, sažmi i provjeri se kroz sve izvore.",
        sourcesTitle: "Izvori u ovom radnom prostoru",
        sourcesEmptyTitle: "Još nema izvora",
        sourcesEmptyBody: "Učitaj dokument ili dodaj postojeći izvor iz svoje biblioteke da započneš.",
        quizMode: "Kviz",
        examMode: "Ispit",
        loadFailed: "Nije moguće učitati radne prostore.",
        card: {
            sources: "{n} izvora",
            cards: "{n} kartica",
            edit: "Uredi",
            delete: "Izbriši",
            deleteTitle: "Izbrisati radni prostor?",
            deleteBody: "Radni prostor bit će izbrisan. Tvoji izvori NEĆE biti izgubljeni — vraćaju se u tvoju biblioteku.",
            deleteConfirm: "Izbriši",
            deleted: "Radni prostor izbrisan",
            deleteFailed: "Nije moguće izbrisati radni prostor.",
        },
        tabs: {
            chat: "Razgovor",
            compare: "Usporedba",
            summary: "Sažetak",
            cards: "Kartice",
            quiz: "Kviz i ispit",
            sources: "Izvori",
        },
        chat: {
            title: "AI profesor",
            acrossSources: "kroz {n} izvora",
            empty: "Pitaj svog AI profesora bilo što — poznaje sve izvore u ovom radnom prostoru odjednom.",
            placeholder: "Postavi pitanje kroz sve izvore …",
            needSource: "Prvo dodaj barem jedan spreman izvor.",
            suggestions: ["Sažmi ključne pojmove", "Gdje se izvori ne slažu?", "Napravi popis za ispit"],
        },
        compare: {
            title: "Analiza više izvora",
            intro: "Usporedi sve izvore: u čemu se slažu, gdje se nadopunjuju, gdje si proturječe — i koji izvor što najbolje objašnjava.",
            needTwo: "Dodaj barem dva spremna izvora za usporedbu.",
            analyze: "Analiziraj izvore",
            reanalyze: "Ponovno analiziraj",
            done: "Analiza završena",
            failed: "Analiza nije uspjela.",
            outdated: "Izvori su promijenjeni — ponovno analiziraj za ažuran rezultat.",
            consensus: "Konsenzus",
            complementary: "Nadopunjujuće",
            contradictions: "Proturječja",
            noContradictions: "Nisu pronađena stvarna proturječja između izvora.",
            coverage: "Što svaki izvor najbolje objašnjava",
            gaps: "Praznine",
            studyPlan: "Preporuka za učenje",
        },
        summary: {
            title: "Objedinjeni sažetak",
            empty: "Generiraj jedan objedinjeni sažetak kroz sve izvore ovog radnog prostora.",
            generate: "Generiraj sažetak",
            regenerate: "Ponovno generiraj",
            failed: "Sažetak nije uspio.",
            types: { student: "Student", five_min: "5 min", one_min: "1 min", fifteen_min: "15 min", executive: "Executive", action: "Akcija" },
        },
        create: {
            title: "Novi radni prostor",
            editTitle: "Uredi radni prostor",
            nameLabel: "Naziv",
            namePlaceholder: "npr. Neurologija ljetni semestar",
            descLabel: "Opis (neobavezno)",
            descPlaceholder: "O čemu je ovaj radni prostor?",
            iconLabel: "Ikona",
            colorLabel: "Boja",
            createBtn: "Stvori",
            saveBtn: "Spremi",
            created: "Radni prostor stvoren",
            updated: "Radni prostor ažuriran",
            failed: "Nije moguće spremiti radni prostor.",
            nameRequired: "Molimo unesi naziv.",
        },
        addSource: {
            button: "Iz biblioteke",
            title: "Dodaj izvor",
            search: "Pretraži dokumente …",
            add: "Dodaj",
            added: "Dodano: {title}",
            failed: "Nije moguće dodati izvor.",
            inWorkspace: "U radnom prostoru",
            none: "Nema pronađenih dokumenata.",
        },
    },
    library: {
        morning: "Dobro jutro",
        afternoon: "Dobar dan",
        evening: "Dobra večer",
        subtitle: "Tvoja knjižnica znanja — {count} {items}.",
        itemOne: "stavka",
        itemOther: "stavki",
        continueReading: "Nastavi čitati",
        allDocuments: "Svi dokumenti",
        search: "Pretraži naslove…",
        sortRecent: "Najnovije",
        sortTitle: "Naslov A–Ž",
        sortProgress: "Napredak",
        sortLength: "Duljina",
        emptyTitle: "Tvoja knjižnica je prazna",
        emptyBody: "Učitaj PDF, EPUB, DOCX ili zalijepi poveznicu — ili isprobaj primjer i vidi čaroliju za 30 sekundi.",
        trySample: "Isprobaj primjer",
        noMatch: "Nema dokumenata koji odgovaraju „{query}“.",
        loadFailed: "Knjižnicu nije moguće učitati",
        deleted: "Izbrisano",
        deleteFailed: "Brisanje nije uspjelo",
        sampleAdded: "Primjer dodan — pročitajmo ga zajedno",
        sampleFailed: "Primjer nije moguće učitati",
        processingReady: "„{title}“ je spreman za čitanje",
        processingFailed: "Dokument nije moguće obraditi",
    },
    upload: {
        addContent: "Dodaj sadržaj",
        title: "Dodaj u knjižnicu",
        tabFile: "Datoteka",
        tabUrl: "URL",
        tabText: "Tekst",
        dropTitle: "Ispusti datoteku ili klikni za odabir",
        dropHint: "PDF, EPUB, DOCX, TXT, MD · do 100 MB",
        urlLabel: "URL članka / web stranice",
        urlPlaceholder: "https://primjer.com/clanak",
        importArticle: "Uvezi članak",
        titleLabel: "Naslov (neobavezno)",
        titlePlaceholder: "Moje bilješke",
        pasteLabel: "Zalijepi tekst",
        pastePlaceholder: "Zalijepi bilo koji sadržaj ovdje…",
        addText: "Dodaj tekst",
        added: "Dodano „{title}“",
        imported: "Uvezeno „{title}“",
        processing: "„{title}“ učitano — tekst se izdvaja u pozadini…",
        uploadFailed: "Učitavanje nije uspjelo",
        urlFailed: "URL nije moguće uvesti",
        textFailed: "Tekst nije moguće dodati",
        pasteMore: "Zalijepi više teksta",
    },
    card: {
        resume: "Nastavi",
        read: "Čitaj",
        reread: "Ponovno čitaj",
        study: "Uči i zapamti",
        processing: "Obrada…",
        processingHint: "Tekst se izdvaja — velike datoteke traju trenutak.",
        ocrHint: "Skenirani dokument — stranice se čitaju pomoću AI-a…",
        ocrProgress: "AI čita stranicu {done} od {total}…",
        failed: "Neuspjelo",
        failedHint: "Ovu datoteku nije moguće obraditi. Pokušaj je ponovno učitati.",
        retrying: "Ponovni pokušaj — tekst se ponovno izdvaja…",
        deleteTitle: "Izbrisati ovaj dokument?",
        deleteBody: "Ovo trajno uklanja dokument i njegov napredak čitanja.",
        deleteConfirm: "Izbriši",
        cancel: "Odustani",
    },
    profile: {
        title: "Profil",
        subtitle: "Upravljaj svojim računom i planom.",
        signOut: "Odjava",
        planSuffix: "plan",
        library: "knjižnica",
        hours: "sati",
        streak: "niz",
        plans: "Planovi",
        current: "trenutno",
        language: "Jezik",
        languageHelp: "Odaberi jezik za sučelje i novi AI sadržaj.",
        viewPlans: "Pogledaj planove i cijene",
        manageBilling: "Upravljaj naplatom",
        upgradeCta: "Otključaj neograničeno učenje",
        upgradeBody: "Nadogradi na Pro ili Premium za neograničena učitavanja, AI i ispitne alate.",
        tiers: [
            { name: "Free", desc: "Doživi vrijednost", features: ["Ograničena učitavanja", "AI sažeci", "Osnovno brzo čitanje"] },
            { name: "Pro", desc: "Za većinu studenata i profesionalaca", features: ["Sve neograničeno", "Ispitni način", "AI trener"] },
            { name: "Premium", desc: "Potpuni AI mentor", features: ["Napredno praćenje pamćenja", "Otkrivanje praznina u znanju", "Prioritetni AI"] },
        ],
    },
    pricing: {
        badge: "Cijene",
        title: "Odaberi svoj plan učenja",
        subtitle: "Započni besplatno. Nadogradi kad budeš spreman učiti bez ograničenja.",
        perMonth: "/ mjesec",
        free: "Free",
        mostPopular: "Najpopularnije",
        completeTutor: "Potpuni AI mentor",
        currentPlan: "Trenutni plan",
        cancelAnytime: "Otkaži bilo kada",
        plusPrevious: "Sve iz Pro plana, plus:",
        backToApp: "Natrag u aplikaciju",
        cta: { startFree: "Započni besplatno", upgradePro: "Nadogradi na Pro", upgradePremium: "Nadogradi na Premium", current: "Tvoj trenutni plan", signInToUpgrade: "Prijavi se za nadogradnju" },
        notConfigured: { title: "Naplata još nije konfigurirana", body: "Plaćanja uskoro kreću. Istraži sve planove sada — sigurna naplata otvara se kad se naplata omogući." },
        states: { processing: "Potvrđujemo tvoje plaćanje…", success: "Dobrodošao! Tvoj plan je sada aktivan.", cancelled: "Naplata otkazana — nije naplaćeno." },
        tiers: {
            free: { name: "Free", tagline: "Doživi vrijednost", features: ["Ograničena učitavanja", "AI sažeci", "Osnovno brzo čitanje", "Ograničen razgovor s dokumentima", "Ograničene kartice", "Ograničeni kvizovi", "Osnovna analitika"] },
            pro: { name: "Pro", tagline: "Za većinu studenata i profesionalaca", features: ["Neograničena učitavanja", "Neograničeni AI sažeci", "Neograničeno brzo čitanje", "Neograničen razgovor s dokumentima", "Neograničena ekstrakcija znanja", "Potpuna analitika", "Kartice", "Generator kvizova", "Ispitni način", "AI trener"] },
            premium: { name: "Premium", tagline: "Za ozbiljnu pripremu ispita", features: ["Napredno praćenje pamćenja", "Otkrivanje praznina u znanju", "Napredni AI trener", "Prioritetna AI obrada", "Staze učenja (uskoro)", "Značajke suradnje (uskoro)", "Grupe za učenje (uskoro)", "Timske značajke (uskoro)"] },
        },
    },
    ambassador: {
        badge: "Program ambasadora",
        title: "LearnOS program ambasadora",
        subtitle: "Radije ulažemo u svoju zajednicu nego u skupo oglašavanje. Podijeli LearnOS, pomozi drugima učiti — i budi nagrađen.",
        note: "Nisi prodavač — dio si putovanja. Hvala što pomažeš LearnOS-u rasti.",
        yourCode: "Tvoj kod za pozivnicu",
        yourLink: "Tvoj link za pozivnicu",
        copyCode: "Kopiraj kod",
        copyLink: "Kopiraj link",
        copied: "Kopirano u međuspremnik",
        howItWorks: "Kako radi",
        steps: [
            { title: "Podijeli svoj link", desc: "Pozovi prijatelje, kolege ili suradnike na LearnOS." },
            { title: "Oni uče s LearnOS-om", desc: "Kada nadograde na plaćeni plan, postaju aktivni član." },
            { title: "Ti si nagrađen", desc: "Zaradi ponavljajuće nagrade i otključaj besplatne mjesece." },
        ],
        stats: { total: "Ukupno pozvano", active: "Aktivni članovi", pending: "Na čekanju" },
        rewardsTitle: "Tvoje nagrade",
        perReferral: "{amount} € po aktivnom članu / mjesec",
        estimate: "Procijenjeno mjesečno",
        approved: "Odobreno mjesečno",
        paidOut: "Ukupno isplaćeno",
        pendingReview: "Čeka pregled",
        milestonesTitle: "Prekretnice nagrada",
        earned: "Postignuto",
        locked: "Zaključano",
        proMonth: "1 mjesec Pro besplatno",
        premiumMonth: "1 mjesec Premium besplatno",
        milestoneProgress: "{count} / {target} aktivnih članova",
        nextReward: "Još {remaining} aktivnih članova za {reward}",
        allUnlocked: "Sjajno — otključao si sve prekretnice!",
        membersTitle: "Tvoji pozvani članovi",
        member: "Član",
        status: "Status",
        joined: "Pridružio se",
        membersEmpty: "Još nema pozivnica. Podijeli svoj link za početak.",
        statuses: { pending: "Na čekanju", active: "Aktivan", rejected: "Odbijen" },
        payoutsTitle: "Tvoje isplate",
        payoutsEmpty: "Još nema isplata — nastavi dijeliti!",
        amount: "Iznos",
        period: "Razdoblje",
    },
    admin: {
        title: "Admin",
        subtitle: "LearnOS operativni centar.",
        notAuthorizedTitle: "Nemaš pristup",
        notAuthorizedBody: "Nemaš pristup admin području.",
        tabs: { overview: "Pregled", users: "Korisnici", referrals: "Preporuke", payouts: "Isplate" },
        overview: { totalUsers: "Ukupno korisnika", free: "Free", pro: "Pro", premium: "Premium", paying: "Plaćaju", mrr: "Procijenjeni MRR", referrals: "Preporuke", activeReferrals: "Aktivne", growth: "Rast preporuka · 14 dana", topAmbassadors: "Najbolji ambasadori", noAmbassadors: "Još nema ambasadora.", pendingPayouts: "Isplate na čekanju", activeMembers: "aktivnih" },
        users: { search: "Traži po imenu, e-pošti ili kodu…", name: "Ime", email: "E-pošta", plan: "Plan", paying: "Plaća", joined: "Pridružio se", actions: "Akcije", markPaying: "Označi kao plaćeno", unmark: "Ukloni", yes: "Da", no: "Ne", updated: "Korisnik ažuriran", empty: "Nema pronađenih korisnika.", createPayout: "Stvori isplatu" },
        referrals: { ambassador: "Ambasador", member: "Član", status: "Status", commission: "Provizija", actions: "Akcije", approve: "Odobri", reject: "Odbij", updated: "Preporuka ažurirana", empty: "Još nema preporuka.", filterAll: "Sve", filterActive: "Aktivne", filterPending: "Na čekanju" },
        payouts: { ambassador: "Ambasador", amount: "Iznos", period: "Razdoblje", status: "Status", actions: "Akcije", approve: "Odobri", markPaid: "Označi kao isplaćeno", reject: "Odbij", created: "Isplata stvorena", updated: "Isplata ažurirana", empty: "Još nema isplata." },
        commissionStatus: { none: "Nijedan", eligible: "Prihvatljivo", approved: "Odobreno", rejected: "Odbijeno" },
        payoutStatus: { pending: "Na čekanju", approved: "Odobreno", paid: "Isplaćeno", rejected: "Odbijeno" },
    },
    billing: {
        notConfigured: "Naplata još nije konfigurirana",
        comingSoon: "Naplata uskoro",
        manage: "Upravljaj naplatom",
        viewPlans: "Pogledaj planove",
        upgrade: "Nadogradi",
    },
    explain: {
        title: "Brzo objašnjenje",
        loading: "Razumijevanje…",
        error: "Trenutačno nije moguće objasniti.",
        retry: "Pokušaj ponovno",
        definition: "Definicija",
        simply: "Jednostavno rečeno",
        whyMatters: "Zašto je važno",
        examRelevance: "Na ispitima",
        memoryTip: "Savjet za pamćenje",
        related: "Povezani pojmovi",
        inPassage: "U ovom odlomku",
        save: "Spremi",
        saved: "Spremljeno",
        note: "Bilješka",
        notePlaceholder: "Dodaj bilješku o ovom pojmu…",
        noteSaved: "Bilješka spremljena",
        saveNote: "Spremi bilješku",
        flashcard: "Kartica",
        addedFlashcard: "Dodano u kartice",
        askAI: "Pitaj AI",
        revisited: "Pregledano {n}×",
        askQuestion: "Objasni ovaj pojam u kontekstu ovog dokumenta: „{term}”",
        selectionHint: "Označi bilo koji tekst da ga objasniš",
    },
    learningProfile: {
        title: "Pojmovi koje istražuješ",
        subtitle: "Pojmovi koje si pregledao tijekom čitanja. Ponovi one koji se stalno vraćaju.",
        empty: "Klikni na istaknuti pojam tijekom čitanja za trenutačno objašnjenje. Pojmovi koje istražuješ pojavit će se ovdje.",
        saved: "{n} spremljenih pojmova",
        revisit: "možda ponoviti",
        frequently: "Često pregledavano",
        suggestedReview: "Predloženo za ponavljanje",
    },
    glossary: {
        nav: "Moj glosar",
        title: "Moj glosar",
        subtitle: "Tvoja osobna knjižnica pojmova — svaki pojam koji si spremio tijekom čitanja.",
        count: "{n} pojmova",
        search: "Pretraži pojmove, bilješke, dokumente…",
        filters: { all: "Sve", recent: "Nedavno spremljeno", revisited: "Najčešće pregledavano", review: "Za ponavljanje", understood: "Shvaćeno", flashcards: "U karticama" },
        allDocuments: "Svi dokumenti",
        allDomains: "Sva područja",
        status: { new: "Novo", review: "Ponoviti", understood: "Shvaćeno" },
        domain: { medical: "Medicina", legal: "Pravo", business: "Poslovanje", general: "Općenito" },
        revisitsLabel: "Pregledano {n}×",
        savedOn: "Spremljeno {date}",
        inFlashcards: "U karticama",
        fields: { definition: "Definicija", simply: "Jednostavno rečeno", whyMatters: "Zašto je važno", examRelevance: "Na ispitima", memoryTip: "Savjet za pamćenje", related: "Povezani pojmovi", source: "Izvor" },
        actions: { open: "Otvori", openDoc: "Otvori dokument", jump: "Skoči na odlomak", ask: "Pitaj AI", addFlashcard: "Dodaj u kartice", added: "U karticama", note: "Bilješka", notePlaceholder: "Tvoja bilješka o ovom pojmu…", saveNote: "Spremi bilješku", remove: "Ukloni" },
        noteSaved: "Bilješka spremljena",
        statusUpdated: "Status ažuriran",
        addedFlashcard: "Dodano u kartice",
        removed: "Uklonjeno iz glosara",
        error: "Nešto je pošlo po zlu.",
        empty: { title: "Izgradi svoju osobnu knjižnicu pojmova", body: "Spremi važne pojmove tijekom čitanja — bit će prikupljeni ovdje za kasnije ponavljanje.", cta: "Otvori dokument i počni istraživati" },
        noResults: "Nijedan pojam ne odgovara filtrima.",
        tour: { title: "Moj glosar", body: "Svaki pojam koji spremiš tijekom čitanja prikuplja se ovdje za kasnije ponavljanje — ponovi ga, dodaj u kartice ili se vrati na izvor." },
    },
    onboarding: {
        badge: "Prvi koraci",
        skip: "Preskoči",
        back: "Natrag",
        next: "Dalje",
        finish: "Završi",
        restart: "Ponovno pokreni obilazak",
        restartHelp: "Ponovno pokreni vođeni obilazak svih LearnOS značajki.",
        guide: "LearnOS vodič",
        stepOf: "Korak {c} od {total}",
        steps: [
            { title: "Dobro došao u LearnOS", body: "Tvoj osobni AI mentor. Učitaj vlastite dokumente i uči brže, razumij više, pamti dulje — i položi ispite." },
            { title: "Počni kako želiš", body: "Ne postoji pogrešan način. Odaberi put koji odgovara tvom stilu učenja — i mijenjaj ga kad god želiš.", chips: ["AI sažetak", "Chat", "Brzo čitanje", "Kartice", "Kviz", "Ispitni način"] },
            { title: "Donesi vlastiti materijal", body: "Učitaj datoteku, zalijepi poveznicu ili ubaci tekst. LearnOS to pretvara u interaktivni prostor za učenje.", chips: ["PDF", "EPUB", "DOCX", "TXT", "Web", "Zalijepi tekst"] },
            { title: "Bit u nekoliko sekundi", body: "Napravi sažetak u dubini koja ti treba. Potpuno neobavezno — preskoči ga kad god želiš.", chips: ["1 min", "5 min", "15 min", "Executive", "Student", "Action"] },
            { title: "Pitaj, ne samo čitaj", body: "Odmah postavljaj pitanja svom dokumentu — bez potrebe da ga prije pročitaš. AI ga već razumije i odgovara s izvorima.", chips: ["Koje je ključno poglavlje?", "Objasni ovaj pojam", "Daj mi primjere", "Usporedi dvije ideje"] },
            { title: "Čitaj na svoj način", body: "Četiri fokusirana načina čitanja, promjenjiva u svakom trenutku. Brzo čitanje je samo jedna opcija — nikad obaveza.", chips: ["RSVP", "Ticker", "Vođeno", "Fokus"] },
            { title: "Usmjerena pažnja", body: "AI ističe ključne pojmove, definicije, činjenice važne za ispit i ključne riječi — da tvoj fokus padne ondje gdje je bitno." },
            { title: "Odmah razumij svaki pojam", body: "Klikni na isticanje za jednostavno objašnjenje, važnost na ispitu, savjet za pamćenje i povezane ideje — ili pitaj AI i spremi ga.", chips: ["Definicija", "Jednostavno", "Važnost na ispitu", "Savjet za pamćenje", "Pitaj AI", "Spremi"] },
            { title: "Tvoja osobna knjižnica pojmova", body: "Svaki spremljeni pojam je u „Mojem glosaru“. Ponovi kasnije, dodaj bilješke, izradi kartice ili skoči natrag na izvor." },
            { title: "Kartice, stvorene za tebe", body: "Automatski iz tvog materijala i spremne za razmaknuto ponavljanje — da stvarno ostane u pamćenju." },
            { title: "Provjeri se", body: "Generiraj kvizove iz vlastitih dokumenata i provjeri što si stvarno razumio." },
            { title: "Vježbaj kao za pravi ispit", body: "Vježbaj realistične ispite i otkrij područja koja još treba doraditi." },
            { title: "Osobno vodstvo", body: "Tvoj AI trener daje preporuke za učenje prilagođene tvom napretku." },
            { title: "Znaj što ponoviti", body: "LearnOS nježno prikazuje pojmove koje bi trebalo ponovno pogledati — iz tvog stvarnog ponašanja u učenju, ne nagađanjem." },
            { title: "Prati svoj napredak", body: "Prati vrijeme čitanja, brzinu, napredak i svoj omiljeni način čitanja kroz vrijeme." },
            { title: "Neka zajednica raste", body: "Pozovi prijatelje i zarađuj ponavljajuće nagrade dok pomažeš LearnOS-u da raste." },
            { title: "Planovi koji odgovaraju", body: "Počni besplatno i nadogradi samo ako trebaš više. Bez pritiska.", chips: ["Free", "Pro", "Premium"] },
            { title: "Sve je spremno", body: "Ne moraš koristiti svaku funkciju. Neki samo sažimaju i chataju; drugi brzo čitaju, vježbaju kartice ili rade ispite. LearnOS se prilagođava tebi — istraži i izgradi vlastiti način učenja." },
        ],
    },
    reader: {
        back: "Natrag u knjižnicu",
        words: "riječi",
        loadFailed: "Dokument se nije mogao učitati",
        aiTools: "AI",
        modes: {
            rsvp: { label: "RSVP", hint: "RSVP način — brzo čitanje riječ po riječ" },
            ticker: { label: "Ticker", hint: "Ticker način — pomični tok teksta" },
            focus: { label: "Fokus", hint: "Fokusirano čitanje — vođeno, redak po redak" },
            guided: { label: "Vođeno", hint: "Vođeno čitanje — cijela stranica miruje dok te AI vodič vodi kroz nju" },
        },
    },
    panels: { summaries: "Sažeci", chat: "Razgovor", knowledge: "Znanje" },
    summaries: {
        title: "AI sažeci",
        auto: "Auto",
        generate: "Izradi {label} sažetak",
        regenerate: "Ponovno izradi",
        empty: "Odaberi duljinu sažetka da destiliraš ovaj dokument u nekoliko sekundi.",
        error: "Sažetak se nije mogao izraditi",
        types: { one_min: "1 min", five_min: "5 min", fifteen_min: "15 min", executive: "Izvršni", student: "Student", action: "Akcija" },
    },
    chat: {
        title: "Razgovor s knjigom",
        empty: "Pitaj bilo što o ovom dokumentu. Odgovori navode točne odlomke.",
        placeholder: "Pitaj o ovom dokumentu…",
        sending: "Čitam izvore…",
        sendHint: "za slanje",
        newlineHint: "Shift+Enter za novi redak",
        error: "Razgovor nije uspio",
        errorMsg: "_Nažalost, na to nisam mogao odgovoriti. Pokušaj ponovno._",
        suggestions: [
            "Koja je glavna poruka?",
            "Daj mi ključne pouke.",
            "Gdje se raspravlja o središnjoj ideji?",
            "Preispitaj autorov argument.",
        ],
        quick: {
            simpler: "Objasni jednostavnije",
            deeper: "Detaljnije",
            examples: "Daj primjere",
            examQ: "Napravi ispitno pitanje",
            flashcard: "Spremi kao karticu",
        },
        quickPrompt: {
            simpler: "Objasni svoj zadnji odgovor jednostavnije, jasnim, svakodnevnim riječima.",
            deeper: "Idi dublje u svoj zadnji odgovor — s detaljima i pozadinom.",
            examples: "Daj mi konkretne primjere za svoj zadnji odgovor.",
            examQ: "Sastavi tipično ispitno pitanje o svom zadnjem odgovoru i kratko ga odgovori.",
        },
        card: {
            preview: "Pregled kartice",
            creating: "Izrađujem karticu …",
            front: "Prednja strana",
            back: "Stražnja strana",
            save: "Spremi karticu",
            cancel: "Odustani",
            saved: "Kartica spremljena",
            duplicate: "Ova kartica već postoji u tvom špilu.",
            failed: "Karticu nije moguće izraditi.",
        },
    },
    overview: {
        button: "Pregled",
        title: "Pregled isticanja",
        subtitle: "Sva označena mjesta — za brzo ponavljanje i skok.",
        all: "Sve",
        empty: "Još nema isticanja za prikaz. Uključi slojeve ili generiraj AI pametna isticanja.",
        count: "{n} mjesta",
        jump: "Skoči na mjesto",
        explain: "Objasni",
        noMatch: "Nema rezultata u ovoj kategoriji.",
        position: "Pozicija {n}%",
    },
    knowledge: {
        title: "Znanje",
        empty: "Izdvoji najvažnije uvide, radnje, citate, koncepte i mentalne modele.",
        generate: "Izdvoji znanje",
        error: "Izdvajanje nije uspjelo",
        insights: "Ključni uvidi",
        actions: "Radnje",
        quotes: "Citati",
        concepts: "Koncepti",
        models: "Mentalni modeli",
    },
    learn: {
        title: "Učenje",
        subtitle: "Čitaj → Razumij → Zapamti → Ovladaj.",
        dueTitle: "{n} kartica za ponavljanje",
        dueSubtitle: "Razmaknuto ponavljanje sprječava blijeđenje znanja.",
        startReview: "Pokreni ponavljanje",
        statFlashcards: "Kartice",
        statMastered: "Svladano",
        statQuizzes: "Kvizovi",
        statAvgQuiz: "Prosj. kviz",
        growth: "Rast znanja",
        states: { new: "Novo", learning: "Učenje", familiar: "Poznato", mastered: "Svladano" },
        achievements: "Postignuća",
        masteryByDoc: "Ovladavanje po dokumentu",
        masteryEmpty: "Pročitaj dokument i izradi kartice da počneš graditi ovladavanje.",
    },
    study: { mode: "Način učenja", exam: "Ispit", tabRecap: "Pregled", tabFlashcards: "Kartice", tabQuiz: "Kviz", tabReflect: "Promisli", loadFailed: "Učitavanje nije uspjelo" },
    examPage: { mode: "Ispitni način", mockTitle: "Vremenski ograničen probni ispit", mockDesc: "Izrađen isključivo iz ovog dokumenta. Ispit se automatski predaje kad istekne vrijeme.", loadFailed: "Učitavanje nije uspjelo" },
    review: {
        title: "Razmaknuto ponavljanje",
        allCaughtTitle: "Sve riješeno!",
        allCaughtBody: "Trenutno nema kartica za ponavljanje. Izradi još kartica ili se vrati kasnije.",
        backToLearning: "Natrag na učenje",
        completeTitle: "Ponavljanje dovršeno!",
        completeBodyGreat: "Ponovio si {n} kartica. Odlično pamćenje!",
        completeBodyNeed: "Ponovio si {n} kartica. {again} treba uskoro još jednom pogledati.",
        loadFailed: "Ponavljanja se nisu mogla učitati",
    },
    analytics: {
        title: "Analitika čitanja",
        subtitle: "Tvoj zamah učenja na prvi pogled.",
        streak: "Niz",
        hoursRead: "Sati čitanja",
        avgWpm: "Prosj. WPM",
        fastestWpm: "Najbrži WPM",
        inLibrary: "U knjižnici",
        completed: "Dovršeno",
        wordsRead: "Pročitane riječi",
        retention: "Zadržavanje",
        daysSuffix: "dana",
        hoursSuffix: "h",
        wpmTrend: "WPM trend (14 dana)",
        minutesTrend: "Pročitane minute (14 dana)",
        readingStyle: "Stil čitanja",
        readingStyleDesc: "Koji način čitanja zapravo najviše koristiš.",
        prefers: "Preferira {mode}",
        readingStyleEmpty: "Počni čitati u bilo kojem načinu da vidiš svoj stil ovdje.",
        sessions: "sesija",
        minShort: "min",
        activity: "Aktivnost (zadnjih 7 tjedana)",
        less: "manje",
        more: "više",
        achievements: "Postignuća",
        badges: { first: "Prvo čitanje", streak3: "Niz od 3 dana", fast: "Brzina 500+", finisher: "Završitelj", scholar: "Učenjak" },
    },
    docpicker: {
        study: { title: "Kartice", subtitle: "Odaberi knjigu za izradu i učenje kartica.", emptyTitle: "Izgradi aktivno prisjećanje", emptyBody: "Kartice pretvaraju svaki dokument u razmaknuto ponavljanje — najbrži način da znanje ostane. Dodaj knjigu za početak." },
        exam: { title: "Ispitni način", subtitle: "Odaberi knjigu za vremenski ograničen probni ispit iz nje.", emptyTitle: "Vježbaj u stvarnim uvjetima", emptyBody: "Vremenski ograničeni probni ispiti iz tvog materijala pokazuju jesi li stvarno spreman. Dodaj knjigu za početak." },
        cards: "kartica",
        quizzes: "kvizova",
        ctaStudy: "Uči kartice",
        ctaExam: "Pokreni ispit",
        goToLibrary: "Idi u knjižnicu",
    },
    deck: {
        generate: "Izradi kartice",
        generateMore: "Izradi još kartica",
        generateBtn: "Izradi",
        types: { basic: "P&O", concept: "Koncept", fill_blank: "Dopuni", reasoning: "Obrazloženje" },
        cardTypes: "Vrste kartica",
        difficulty: "Težina",
        count: "Broj",
        diffs: { beginner: "Početnik", intermediate: "Srednje", advanced: "Napredno" },
        pickType: "Odaberi barem jednu vrstu kartice",
        created: "Izrađeno {n} kartica",
        genFailed: "Izrada nije uspjela",
        cards: "kartica",
        studyThese: "Uči ove",
        backToDeck: "Natrag na špil",
        reviewComplete: "Sesija ponavljanja dovršena",
        editTitle: "Uredi karticu",
        front: "Prednja strana",
        back: "Stražnja strana",
        saved: "Spremljeno",
        saveFailed: "Spremanje nije uspjelo",
        regenerated: "Kartica ponovno izrađena",
        regenFailed: "Ponovna izrada nije uspjela",
    },
    quiz: {
        questionTypes: "Vrste pitanja",
        difficulty: "Težina",
        questions: "Pitanja",
        timeLimit: "Vremensko ograničenje",
        startQuiz: "Pokreni kviz",
        startExam: "Pokreni ispit",
        types: { mcq: "Višestruki izbor", true_false: "Točno / Netočno", open: "Otvoreno pitanje", scenario: "Scenarij", case_study: "Studija slučaja", exam: "Ispitno pitanje" },
        diffs: { beginner: "Početnik", intermediate: "Srednje", advanced: "Napredno" },
        craftingQuiz: "Izrađujem tvoj kviz…",
        craftingExam: "Izrađujem tvoj ispit…",
        question: "Pitanje {i} / {n}",
        answered: "{n} odgovoreno",
        back: "Natrag",
        next: "Dalje",
        submit: "Predaj",
        correctCount: "{correct} / {total} točno",
        recommendedReview: "Preporučeno ponavljanje",
        noWeak: "Nema slabih točaka — izvrsno!",
        done: "Gotovo",
        yourAnswer: "tvoj odgovor",
        feedback: "Povratna informacija",
        modelAnswer: "ogledni odgovor",
        correctAnswer: "Točan odgovor:",
        typeAnswer: "Upiši svoj odgovor…",
        trueLabel: "Točno",
        falseLabel: "Netočno",
        genFailed: "Izrada kviza nije uspjela",
        submitFailed: "Predaja nije uspjela",
        score: "bodovi",
    },
    fcReview: {
        card: "Kartica {i} / {n}",
        question: "Pitanje",
        answer: "Odgovor",
        reveal: "Prikaži odgovor",
        space: "(razmaknica)",
        hint: "Savjet",
        again: "Ponovno",
        hard: "Teško",
        good: "Dobro",
        easy: "Lako",
    },
    coach: {
        title: "AI trener učenja",
        focusTopics: "Teme za fokus",
        nextSteps: "Sljedeći koraci",
        empty: "Čitaj i ponavljaj još malo, tada će tvoj trener imati uvide za tebe.",
    },
    reflection: {
        intro: "Promisli da zapamtiš. Pisanje vlastitim riječima dramatično povećava zadržavanje.",
        placeholder: "Napiši svoju refleksiju…",
        loadFailed: "Pitanja za refleksiju se nisu mogla učitati",
    },
    scores: { reading: "Čitanje", understanding: "Razumijevanje", retention: "Zadržavanje", mastery: "Ovladavanje" },
    completion: {
        title: "Dokument dovršen!",
        body: "Završio si {title}.",
        faster: "Pročitao si ga otprilike {min} min brže od prosjeka.",
        words: "riječi",
        yourSpeed: "tvoja brzina",
        timeSaved: "ušteđeno vrijeme",
        wpm: "WPM",
        min: "min",
        studyToRemember: "Uči da zapamtiš",
        readSummary: "Pročitaj sažetak",
        ask: "Pitaj",
        library: "Knjižnica",
    },
    achievements: {
        earned: "osvojeno",
        items: {
            first_book: { label: "Prva knjiga dovršena", desc: "Završi svoj prvi dokument" },
            streak10: { label: "Niz od 10 dana", desc: "Čitaj 10 dana zaredom" },
            cards100: { label: "100 svladanih kartica", desc: "Svladaj 100 kartica" },
            quiz90: { label: "90% na kvizu", desc: "Ostvari 90%+ na kvizu" },
            words100k: { label: "100.000 pročitanih riječi", desc: "Pročitaj 100k riječi" },
            builder: { label: "Graditelj znanja", desc: "Izradi 50 kartica" },
            fast_learner: { label: "Brzi učenik", desc: "Prosjek 400+ WPM" },
            master_reader: { label: "Majstor čitanja", desc: "Dosegni 80% ovladavanja dokumentom" },
        },
    },
    detail: {
        label: "Dubina",
        quick: "Brzo", standard: "Standard", expert: "Ekspert",
        quickHint: "Kratko i izravno", standardHint: "Jasno i strukturirano",
        expertHint: "Sveučilišna razina — temeljito, ispitno orijentirano",
    },
    pro: {
        deepDive: "Dubinski",
        improve: "Poboljšaj", harder: "Otežaj",
        fromWeak: "Uči slabe točke", fromWeakDesc: "Izradi kartice iz tvojih slabih tema",
        noWeak: "Još nema slabih tema — prvo napravi kviz.",
        weakGenerated: "Izrađeno {n} kartica za slabe teme",
        whatCorrect: "Što je točno", whatMissing: "Što je nedostajalo", whatWrong: "Što je pogrešno",
        examinerNote: "Bilješka ispitivača", howToImprove: "Kako se poboljšati",
        commonMistake: "Čest pogreška", advice: "Savjet za učenje",
    },
};

export default hr;
